import {Injectable} from '@angular/core';

import {RequestService} from 'app/core/services/request.service';
import {ConfigService} from 'app/core/services/config.service';

@Injectable()
export class SellerSettlementsService {

    constructor(
        private requestService: RequestService,
        private configService: ConfigService
    ) {
    }

    getSettlementListAPI() {
        return this.configService.get('server').url + this.configService.get('endpoints').odyssey.settlements.list.api;
    }

    getSettlementPlatformListAPI() {
        return this.configService.get('server').url + this.configService.get('endpoints').odyssey.settlements.listForPlatformUsersByKey.api;
    }

    fetchSettlementList(status) {
        const url = this.configService.get('server').url + this.configService.get('endpoints').odyssey.settlements.listForPlatformUsersByKey.api;
        return this.requestService.get(url + '?configKey=' + status);
    }

    fetchBatchDetail(batchId) {
        const url = this.configService.get('server').url + this.configService.get('endpoints').odyssey.settlements.settlementDetails.api;
        return this.requestService.get(url + '?batchId=' + batchId);
    }
    getTotalEarnings() {
        let url = this.configService.get('server').url + this.configService.get('endpoints').odyssey.settlements.totalEarnings.api;
        return this.requestService.get(url);
    }

    fetchSettlementDetails(id: string) {
        const url = this.configService.get('server').url + this.configService.get('endpoints').odyssey.settlements.settlementDetailsById.api + '/' + id;
        return this.requestService.get(url);
    }
}




// WEBPACK FOOTER //
// ./src/app/solar/seller-exam-fulfillment/settlement-report/seller-settlements.service.ts